import { render } from "./MatrixRequestCard.vue?vue&type=template&id=eb5ac1d4"
import script from "./MatrixRequestCard.vue?vue&type=script&lang=js"
export * from "./MatrixRequestCard.vue?vue&type=script&lang=js"

import "./MatrixRequestCard.vue?vue&type=style&index=0&id=eb5ac1d4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__